var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "main",
    { staticClass: "col content-spacing", attrs: { role: "main" } },
    [
      _vm.viewData.loading
        ? _c("loading-list")
        : _c(
            "b-container",
            [
              _c(
                "b-row",
                [
                  _c("b-col", [
                    _c(
                      "div",
                      {
                        staticClass:
                          "d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center pt-3 pb-2 mb-3 border-bottom"
                      },
                      [
                        _c("h1", { staticClass: "h2" }, [
                          _vm._v(
                            "\n            " +
                              _vm._s(
                                _vm.viewData.id
                                  ? `Editar ${_vm.state.name}`
                                  : "Nova Distribuidora"
                              ) +
                              "\n          "
                          )
                        ])
                      ]
                    )
                  ])
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-row",
                [
                  _c(
                    "b-col",
                    [
                      _c("b-breadcrumb", {
                        attrs: {
                          items: [
                            {
                              text: "Lista de Distribuidoras",
                              href: "#/distributors"
                            },
                            {
                              text: "Cadastro de Distribuidoras",
                              href: "#",
                              active: true
                            }
                          ]
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-row",
                [
                  _c(
                    "b-col",
                    [
                      _c(
                        "b-card",
                        [
                          _c(
                            "b-form",
                            [
                              _c("error-container", {
                                attrs: { errors: _vm.viewData.errors || [] }
                              }),
                              _vm._v(" "),
                              _c(
                                "b-form-group",
                                { attrs: { label: "Nome (Sigla)" } },
                                [
                                  _c("b-form-input", {
                                    attrs: {
                                      required: "",
                                      placeholder: "Informe o nome",
                                      state: _vm.isOk("name")
                                    },
                                    model: {
                                      value: _vm.state.name,
                                      callback: function($$v) {
                                        _vm.$set(_vm.state, "name", $$v)
                                      },
                                      expression: "state.name"
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c("b-form-invalid-feedback", [
                                    _vm._v(_vm._s(_vm.getError("name")))
                                  ])
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "b-form-group",
                                { attrs: { label: "CNPJ" } },
                                [
                                  _c("b-form-input", {
                                    directives: [
                                      {
                                        name: "mask",
                                        rawName: "v-mask",
                                        value: ["##.###.###/####-##"],
                                        expression: "['##.###.###/####-##']"
                                      }
                                    ],
                                    attrs: {
                                      required: "",
                                      placeholder: "Informe o CNPJ",
                                      state: _vm.isOk("socialNumber")
                                    },
                                    model: {
                                      value: _vm.state.socialNumber,
                                      callback: function($$v) {
                                        _vm.$set(_vm.state, "socialNumber", $$v)
                                      },
                                      expression: "state.socialNumber"
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c("b-form-invalid-feedback", [
                                    _vm._v(_vm._s(_vm.getError("socialNumber")))
                                  ])
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "b-form-group",
                                {
                                  attrs: {
                                    id: "input-group-3",
                                    label: "Denominação",
                                    "label-for": "input-group-3"
                                  }
                                },
                                [
                                  _c(
                                    "b-form-select",
                                    {
                                      attrs: { state: _vm.isOk("initials") },
                                      model: {
                                        value: _vm.state.initials,
                                        callback: function($$v) {
                                          _vm.$set(_vm.state, "initials", $$v)
                                        },
                                        expression: "state.initials"
                                      }
                                    },
                                    [
                                      _c(
                                        "option",
                                        { attrs: { disabled: "", value: "" } },
                                        [_vm._v("Selecione a denominação")]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "option",
                                        {
                                          attrs: {
                                            value: "CEMIG (Minas Gerais)"
                                          }
                                        },
                                        [_vm._v("CEMIG (Minas Gerais)")]
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c("b-form-invalid-feedback", [
                                    _vm._v(_vm._s(_vm.getError("initials")))
                                  ])
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "b-form-group",
                                {
                                  attrs: {
                                    id: "input-group-3",
                                    label: "Fluxo de cadastro da UC",
                                    "label-for": "input-group-3"
                                  }
                                },
                                [
                                  _c(
                                    "b-form-select",
                                    {
                                      attrs: { state: _vm.isOk("ucFlow") },
                                      model: {
                                        value: _vm.state.ucFlow,
                                        callback: function($$v) {
                                          _vm.$set(_vm.state, "ucFlow", $$v)
                                        },
                                        expression: "state.ucFlow"
                                      }
                                    },
                                    [
                                      _c(
                                        "option",
                                        { attrs: { disabled: "", value: "" } },
                                        [_vm._v("Selecione o fluxo")]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "option",
                                        {
                                          attrs: {
                                            value: "WITHOUT_LOGIN_WITHOUT_ID"
                                          }
                                        },
                                        [_vm._v("Sem login, Sem identidade")]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "option",
                                        {
                                          attrs: {
                                            value: "WITHOUT_LOGIN_WITH_ID"
                                          }
                                        },
                                        [_vm._v("Sem login, Com identidade")]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "option",
                                        {
                                          attrs: {
                                            value: "WITH_LOGIN_WITHOUT_ID"
                                          }
                                        },
                                        [_vm._v("Com login, Sem identidade")]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "option",
                                        {
                                          attrs: { value: "WITH_LOGIN_WITH_ID" }
                                        },
                                        [_vm._v("Com login, Com identidade")]
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c("b-form-invalid-feedback", [
                                    _vm._v(_vm._s(_vm.getError("ucFlow")))
                                  ])
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "b-form-group",
                                {
                                  attrs: {
                                    label: "URL do Portal da Distribuidora"
                                  }
                                },
                                [
                                  _c("b-form-input", {
                                    attrs: {
                                      required: "",
                                      placeholder:
                                        "Informe a URL do Portal da Distribuidora",
                                      state: _vm.isOk("distributorUrl")
                                    },
                                    model: {
                                      value: _vm.state.distributorUrl,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.state,
                                          "distributorUrl",
                                          $$v
                                        )
                                      },
                                      expression: "state.distributorUrl"
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c("b-form-invalid-feedback", [
                                    _vm._v(
                                      _vm._s(_vm.getError("distributorUrl"))
                                    )
                                  ])
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "b-form-group",
                                { attrs: { label: "Código da Distribuidora" } },
                                [
                                  _c("b-form-input", {
                                    attrs: {
                                      required: "",
                                      placeholder:
                                        "Informe o Código da Distribuidora",
                                      state: _vm.isOk("initials")
                                    },
                                    model: {
                                      value: _vm.state.numberDist,
                                      callback: function($$v) {
                                        _vm.$set(_vm.state, "numberDist", $$v)
                                      },
                                      expression: "state.numberDist"
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c("b-form-invalid-feedback", [
                                    _vm._v(_vm._s(_vm.getError("numberDist")))
                                  ])
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "b-form-group",
                                {
                                  attrs: {
                                    id: "input-group-3",
                                    label: "Região",
                                    "label-for": "input-group-3"
                                  }
                                },
                                [
                                  _c(
                                    "b-form-select",
                                    {
                                      attrs: { state: _vm.isOk("region") },
                                      model: {
                                        value: _vm.state.region,
                                        callback: function($$v) {
                                          _vm.$set(_vm.state, "region", $$v)
                                        },
                                        expression: "state.region"
                                      }
                                    },
                                    [
                                      _c(
                                        "option",
                                        { attrs: { disabled: "", value: "" } },
                                        [_vm._v("Selecione a região")]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "option",
                                        { attrs: { value: "norte" } },
                                        [_vm._v("Norte")]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "option",
                                        { attrs: { value: "nordeste" } },
                                        [_vm._v("Nordeste")]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "option",
                                        { attrs: { value: "sul" } },
                                        [_vm._v("Sul")]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "option",
                                        { attrs: { value: "sudeste" } },
                                        [_vm._v("Sudeste")]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "option",
                                        { attrs: { value: "centro_oeste" } },
                                        [_vm._v("Centro Oeste")]
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c("b-form-invalid-feedback", [
                                    _vm._v(_vm._s(_vm.getError("region")))
                                  ])
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "b-form-group",
                                {
                                  attrs: {
                                    id: "input-group-1",
                                    label: "Estado",
                                    "label-for": "input-1"
                                  }
                                },
                                [
                                  _c(
                                    "b-form-select",
                                    {
                                      attrs: {
                                        options: _vm.viewData.states,
                                        state: _vm.isOk("state")
                                      },
                                      model: {
                                        value: _vm.state.state,
                                        callback: function($$v) {
                                          _vm.$set(_vm.state, "state", $$v)
                                        },
                                        expression: "state.state"
                                      }
                                    },
                                    [
                                      _c(
                                        "option",
                                        { attrs: { disabled: "", value: "" } },
                                        [_vm._v("Selecione um estado")]
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c("b-form-invalid-feedback", [
                                    _vm._v(_vm._s(_vm.getError("state")))
                                  ])
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "b-form-group",
                                { attrs: { label: "Cidade" } },
                                [
                                  _c("b-form-input", {
                                    attrs: {
                                      placeholder: "Informe a cidade",
                                      state: _vm.isOk("city")
                                    },
                                    model: {
                                      value: _vm.state.city,
                                      callback: function($$v) {
                                        _vm.$set(_vm.state, "city", $$v)
                                      },
                                      expression: "state.city"
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c("b-form-invalid-feedback", [
                                    _vm._v(_vm._s(_vm.getError("city")))
                                  ])
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "b-form-group",
                                {
                                  attrs: {
                                    id: "input-group-1",
                                    label: "Bairro",
                                    "label-for": "input-1"
                                  }
                                },
                                [
                                  _c("b-form-input", {
                                    attrs: {
                                      placeholder: "Informe o Bairro",
                                      state: _vm.isOk("district")
                                    },
                                    model: {
                                      value: _vm.state.district,
                                      callback: function($$v) {
                                        _vm.$set(_vm.state, "district", $$v)
                                      },
                                      expression: "state.district"
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c("b-form-invalid-feedback", [
                                    _vm._v(_vm._s(_vm.getError("district")))
                                  ])
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "b-form-group",
                                {
                                  attrs: {
                                    id: "input-group-1",
                                    label: "Endereço",
                                    "label-for": "input-1"
                                  }
                                },
                                [
                                  _c("b-form-input", {
                                    attrs: {
                                      placeholder: "Informe o Endereço",
                                      state: _vm.isOk("address")
                                    },
                                    model: {
                                      value: _vm.state.address,
                                      callback: function($$v) {
                                        _vm.$set(_vm.state, "address", $$v)
                                      },
                                      expression: "state.address"
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c("b-form-invalid-feedback", [
                                    _vm._v(_vm._s(_vm.getError("address")))
                                  ])
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "b-form-group",
                                {
                                  attrs: {
                                    id: "input-group-1",
                                    label: "Numero",
                                    "label-for": "input-1"
                                  }
                                },
                                [
                                  _c("b-form-input", {
                                    attrs: {
                                      placeholder: "Informe o Número",
                                      state: _vm.isOk("number")
                                    },
                                    on: {
                                      keypress: function($event) {
                                        return _vm.isNumber($event)
                                      }
                                    },
                                    model: {
                                      value: _vm.state.number,
                                      callback: function($$v) {
                                        _vm.$set(_vm.state, "number", $$v)
                                      },
                                      expression: "state.number"
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c("b-form-invalid-feedback", [
                                    _vm._v(_vm._s(_vm.getError("number")))
                                  ])
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "b-form-group",
                                {
                                  attrs: {
                                    id: "input-group-1",
                                    label: "Complemento",
                                    "label-for": "input-1"
                                  }
                                },
                                [
                                  _c("b-form-input", {
                                    attrs: {
                                      placeholder: "Informe o Complemento",
                                      state: _vm.isOk("complement")
                                    },
                                    model: {
                                      value: _vm.state.complement,
                                      callback: function($$v) {
                                        _vm.$set(_vm.state, "complement", $$v)
                                      },
                                      expression: "state.complement"
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c("b-form-invalid-feedback", [
                                    _vm._v(_vm._s(_vm.getError("complement")))
                                  ])
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "b-form-group",
                                {
                                  attrs: {
                                    id: "input-group-1",
                                    label: "Telefone",
                                    "label-for": "input-1"
                                  }
                                },
                                [
                                  _c("b-form-input", {
                                    directives: [
                                      {
                                        name: "mask",
                                        rawName: "v-mask",
                                        value: [
                                          "(##) ####-####",
                                          "(##) #####-####"
                                        ],
                                        expression:
                                          "['(##) ####-####', '(##) #####-####']"
                                      }
                                    ],
                                    attrs: {
                                      required: "",
                                      placeholder: "Informe o Telefone",
                                      state: _vm.isOk("phone")
                                    },
                                    model: {
                                      value: _vm.state.phone,
                                      callback: function($$v) {
                                        _vm.$set(_vm.state, "phone", $$v)
                                      },
                                      expression: "state.phone"
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c("b-form-invalid-feedback", [
                                    _vm._v(_vm._s(_vm.getError("phone")))
                                  ])
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "b-form-group",
                                {
                                  attrs: {
                                    id: "input-group-1",
                                    label: "CEP",
                                    "label-for": "input-1"
                                  }
                                },
                                [
                                  _c("b-form-input", {
                                    directives: [
                                      {
                                        name: "mask",
                                        rawName: "v-mask",
                                        value: ["#####-###"],
                                        expression: "['#####-###']"
                                      }
                                    ],
                                    attrs: {
                                      placeholder: "Informe o CEP",
                                      state: _vm.isOk("zipCode")
                                    },
                                    on: {
                                      blur: function($event) {
                                        return _vm.fillCompleteAddress($event)
                                      }
                                    },
                                    model: {
                                      value: _vm.state.zipCode,
                                      callback: function($$v) {
                                        _vm.$set(_vm.state, "zipCode", $$v)
                                      },
                                      expression: "state.zipCode"
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c("b-form-invalid-feedback", [
                                    _vm._v(_vm._s(_vm.getError("zipCode")))
                                  ])
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "b-form-group",
                                { attrs: { label: "Email" } },
                                [
                                  _c("b-form-input", {
                                    attrs: {
                                      required: "",
                                      placeholder: "Informe o email",
                                      state: _vm.isOk("email")
                                    },
                                    model: {
                                      value: _vm.state.email,
                                      callback: function($$v) {
                                        _vm.$set(_vm.state, "email", $$v)
                                      },
                                      expression: "state.email"
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c("b-form-invalid-feedback", [
                                    _vm._v(_vm._s(_vm.getError("email")))
                                  ])
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c("submit-button", {
                                attrs: {
                                  action: () => _vm.save(),
                                  label: "Salvar"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }